<template>
    <div>
            <!--Footer Wrap Start-->
    <footer>
    	<div class="kode_newsletter_bg" sty>
        	<div class="container">
            	<div class="kode_newsletter_des">
                <div class="">
                    <a href="index.html"><img src="images/logo.png" alt="Logo Image Here" style="width:100%"></a>
                </div>
                </div>
                <div class="kode_newsletter_form">
           
                    <h5 style="color:#fff">DINAS KEPENDUDUKAN DAN PENCATATAN SIPIL</h5>
                </div>
            </div>
        </div>
        
        <div class="kode_footer_bg">
        	<div class="container">
            	<!--Footer Logo Wrap Start-->
 
                <!--Footer Logo Wrap End-->
                
                <!--Footer Widget Wrap Start-->
                <div class="kode_widgt_outr_wrap">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="kode_widgt_touch widget_hdg">
                                <h5>Kontak Kami</h5>
                                <!-- <p>This is Photoshop's version  of Lorem Ipsum. Proin gravida nibh vel..</p> -->
                                <!-- <p><i class="fa fa-map-marker"></i> 360 harvest St, North  Newyork USA</p> -->
                                <p><i class="fa fa-phone"></i> 0853 XXXX XXXX</p>
                                <!-- <p><i class="fa fa-envelope"></i> <a href="#">dukcapil@konaweselatankab.com</a></p> -->
                                <p><i class="fa fa-envelope"></i> <a href="#"> dukcapil@konaweselatankab.com</a> </p>
                                        
                                        
                            </div>
                        </div>
                        
                        <!-- <div class="col-md-3">
                            <div class="kode_widgt_tweets widget_hdg">
                                <h5>Twitter Feed</h5>
                                <ul>
                                    <li>
                                        <i class="fa fa-twitter"></i>
                                        <div class="kode_widgt_des">
                                            <a href="#">@ info,</a>
                                            we have release our 
                                            <span>templates</span> <p> 10 minutes age </p>
                                        </div>
                                    </li>
                                    
                                    <li>
                                        <i class="fa fa-twitter"></i>
                                        <div class="kode_widgt_des">
                                            <a href="#">@ info,</a>
                                            we have release our <span>templates</span> <p> 10 minutes age </p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div> -->
                        
                        <div class="col-md-3">
                            <div class="kode_widgt_event widget_hdg">
                                <h5>Berita Terbaru</h5>
                                <ul>
                                    <li v-for="data in berita" :key="data.id">
                                        <figure>
                                            <a href="javascript:void(0);" @click="push_berita(data.id)"><img :src="file_path+data.foto" alt="Image Here" style="height:80px;width:100px"></a>
                                        </figure>
                                        <div class="kode_foo_event_des">
                                            <a href="javascript:void(0);" @click="push_berita(data.id)">{{data.judul}}</a>
                                            <span>{{convert_tgl(data.createAt)}}</span>
                                        </div>
                                    </li>
                                    
                  
                                </ul>
                            </div>
                        </div>
                        
                        <div class="col-md-3">
                            <div class="kode_foo_gallery widget_hdg">
                                <h5>Galeri Kegiatan</h5>
                                <ul>
                                    <li v-for="data in kegiatan6" :key="data.id"><a href="javascript:void(0);" @click="push_kegiatan(data.id)"><img :src="file_path+data.foto" alt="Image Here" style="height:80px;width:80px" ></a></li>  
                                </ul>
                            </div>
                        </div>
                        
                        
                    </div>
                </div>
                <!--Footer Widget Wrap End-->
                
                <!--Footer Site map Wrap Start-->
                <div class="kode_site_map">
                	<ul>
                    	<li><a href="/">Home</a></li>
                            <li><router-link to="/berita">Berita</router-link></li> 
                            <li><router-link to="/tentang">Tentang</router-link></li>
                            <li><router-link to="/visi">Visi</router-link></li>
                            <li><router-link to="/misi">Misi</router-link></li>
                            <li><router-link to="/struktur_organisasi">Struktur Organisasi</router-link></li>
                            <!-- <li><router-link to="/profil_kependudukan">Profil Kependudukan</router-link></li> -->
                            <!-- <li><router-link to="/data_agregat_kependudukan">Data Agregat Kependudukan</router-link></li> -->
							<li><router-link to="/kegiatan">Kegiatan</router-link></li>
							<li><router-link to="/pengumuman">Pengumuman</router-link></li>
                    </ul>
                </div>
                <!--Footer Site map Wrap End-->
                
                <!--Copy Right Wrap Start-->
                <!-- <div class="kode_copyright">
                	<p>Copyright © Democracy, Designed by <span><a href="#">Kodeforest</a></span> </p>
                    <a class="kode-back-top" href="#"><i class="fa fa-angle-up"></i></a>
                </div> -->
                <!--Copy Right Wrap End-->
                
            </div>
        </div>
        
    </footer>
    <!--Footer Wrap End-->
    </div>
</template>

<script>

// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import {ImageResize} from 'quill-image-resize-module'
// Quill.register('modules/imageResize', ImageResize)


// Quill.register("modules/imageResize", ImageResize);

const ADD_URL = URL_APP + "api/v1/publish_berita/";
const BERITA_URL = URL_APP + "api/v1/publish_berita/";
const KEGIATAN_URL = URL_APP + "api/v1/publish_kegiatan/";

const FILE_LOAD = URL_APP + "uploads/";

export default {
  name: "web_pengumuman",
  data() {
    return {
		id: "",
		id_berita :"",
		createAt : '',
		createBy : '',
		deskripsi : '',
		isi : '',
		judul : '',
		sumber : '',
        foto : '',

        bisi : '',
		bjudul : '',
		bdeskripsi : '',
		bsumber : '',
		bfoto : '',
        

		HOST : URL_HOST+'/isi_berita/',
    file_path: FILE_LOAD,
    
    kegiatan:[],
    kegiatan6:[],
    berita:[],

		list_data: [],
		page_first: 1,
		page_last: 0,
		cari_value: "",


    };
  },

  // =============================================================== METHODS =========================================================================
  // =============================================================== METHODS =========================================================================
  methods: {
    getView: function() {
      fetch(ADD_URL + "view", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value
        })
      })
        .then(res => res.json())
        .then(res_data => {
          this.list_data = res_data.data;
          this.page_last = res_data.jml_data;
            // console.log(res_data);
        });
	},

	
    getOne: function() {
      fetch(ADD_URL + "getOne", {
        method: "get",
        headers: {
          "content-type": "application/json",
        },

      })
        .then(res => res.json())
        .then(res_data => {
        //   this.list_data = res_data.data;
        //   this.page_last = res_data.jml_data;
			// console.log(res_data);

						var berita = res_data[0];
						
						this.id_berita = berita.id;
						this.createAt = berita.createAt;
            this.createBy = berita.createBy;
            this.deskripsi = berita.deskripsi;
            this.isi = berita.isi;
            this.judul = berita.judul;
            this.sumber = berita.sumber;
            this.foto = berita.foto;     
        });
    },

    getBerita: function() {
    fetch(BERITA_URL + "get2", {
        method: "get",
        headers: {
        "content-type": "application/json",
        },

    })
        .then(res => res.json())
        .then(res_data => {
			  this.berita = res_data;
			//   console.log(res_data);
        });
    },    


  getKegiatan: function() {
    fetch(KEGIATAN_URL + "getOne", {
        method: "get",
        headers: {
        "content-type": "application/json",
        },

    })
        .then(res => res.json())
        .then(res_data => {
			  this.kegiatan = res_data;
			//   console.log(res_data);
        });
  },    

    getKegiatan6: function() {
    fetch(KEGIATAN_URL + "get6", {
        method: "get",
        headers: {
        "content-type": "application/json",
        },

    })
        .then(res => res.json())
        .then(res_data => {
			  this.kegiatan6 = res_data;
			//   console.log(res_data);
        });
  }, 

  limit_desk_kegiatan : function(text){
    return text.substring(0, 100)
  },    
	
	push_berita : function(id){
		this.$router.push('/isi_berita/'+id);
	},
	push_kegiatan : function(id){
		this.$router.push('/isi_kegiatan/'+id);
	},

	to_facebook : function () {
        window.open("http://www.facebook.com/sharer.php?u="+this.HOST+this.id_berita, '_blank');
    },
    to_twitter : function(){
        // alert(this.HOST)
        window.open("https://twitter.com/share?url="+this.HOST+this.id_berita+"&amp;text="+this.judul, '_blank');
    },



// ================== PAGINASI ====================
    alertku: function(type, title) {
      this.$swal({
        type: type,
        title: title,
        showConfirmButton: false,
        timer: 800
      });
    },

    btn_prev: function() {
      if (this.page_first > 1) {
        this.page_first--;
      } else {
        this.page_first = 1;
      }
      this.getView();
    },

    btn_next: function() {
      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last;
      } else {
        this.page_first++;
      }
      this.getView();
    },

    cari_data: function() {
      this.getView();
    },

    convert_tgl : function(dateString){
		var date = new Date(dateString);
		var bulan = "";

		if (date.getMonth() == 0) {bulan = 'januari';} 
		else if (date.getMonth() == 1) {bulan = 'Februari';}
		else if (date.getMonth() == 2) {bulan = 'Maret';}
		else if (date.getMonth() == 3) {bulan = 'April';}
		else if (date.getMonth() == 4) {bulan = 'Mei';}
		else if (date.getMonth() == 5) {bulan = 'Juni';}
		else if (date.getMonth() == 6) {bulan = 'Juli';}
		else if (date.getMonth() == 7) {bulan = 'Agustus';}
		else if (date.getMonth() == 8) {bulan = 'September';}
		else if (date.getMonth() == 9) {bulan = 'Oktober';}
		else if (date.getMonth() == 10) {bulan = 'November';}
		else if (date.getMonth() == 11) {bulan = 'Desember';}
		else{bulan = ''}

		return date.getDate()+" "+bulan+" "+date.getFullYear();
	},
// ================== PAGINASI ====================
  },
  // =============================================================== METHODS =========================================================================

  mounted() {
	this.getView();
	this.getOne();
	this.getKegiatan();
	this.getKegiatan6();
	this.getBerita();
  }
};
</script>



